<div class="d-lg-block d-none">
  <fgb-banner [title]="'terms.page.banner' | translate"></fgb-banner>
</div>

<div class="d-lg-none">
  <fgb-mobile-page-header
    pageTitle="terms.page.banner"
    [showFooter]="true"
    [showQr]="false"
    [showBalance]="false"
    [backButtonLink]="'/'"
  ></fgb-mobile-page-header>
</div>

<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="pt-lg-4 terms-page">
        <fgbcl-terms-and-conditions
          [type]="termsAndConditionsType"
          [defaultTerms]="defaultTemplate"
          [ngClass]="isCorporate ? 'corporate' : ''"
        ></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">{{ 'terms.page.placeholder.text' | translate }}</p>
</ng-template>
